import { routes } from '@/routes/routes';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../common/Accordion';
import BackButton from '../common/BackButton';
import { Heading } from '../common/Heading';
import { Section } from '../common/Section';
import {
  Card,
  CardContent,
  CardHeader,
  CardsContainer,
} from '../dashboard/DashboardCard';

export interface HelpFaqProps {
  title: string;
  subtitle: string;
  faq: Array<{
    question: string;
    answer: React.ReactNode;
  }>;
}

export const HelpFaq = ({ title, subtitle, faq }: HelpFaqProps) => {
  return (
    <Section>
      <BackButton to={routes.help.index} className="mb-4">
        Back to help page
      </BackButton>

      <CardsContainer className="-mx-4 lg:mx-0">
        <Card className="gap-3 lg:py-7.5">
          <CardHeader className="gap-3 lg:px-7.5">
            <Heading as="h1" className="text-secondary">
              {title}
            </Heading>
            <Heading asChild size="h3" className="text-secondary">
              <p>{subtitle}</p>
            </Heading>
          </CardHeader>

          <CardContent className="lg:px-7.5">
            <Accordion type="single" collapsible>
              {faq.map((item) => (
                <AccordionItem key={item.question} value={item.question}>
                  <AccordionTrigger className="text-secondary text-lg">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="prose">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>
      </CardsContainer>
    </Section>
  );
};
